import { ActionMeta } from "../../../model/ActionMeta";
import { OrganizationKeyName } from "../../../model/Organization";

export const UPSERT_PRODUCT = "SHOP:UPSERT_PRODUCT";

export const upsertProductAction = (
  organization: OrganizationKeyName,
  data: any,
  id?: string,
  productImage?: File,
  meta?: ActionMeta
) => ({
  type: UPSERT_PRODUCT as typeof UPSERT_PRODUCT,
  organization,
  data,
  id,
  productImage,
  ...meta,
});

export type UpsertProductAction = ReturnType<typeof upsertProductAction>;
